import { Video, AudioFeatures } from '@meradio/shared-types';
import { formatKeyShort, getCamelotKey } from '@meradio/music-utils';

export interface DeckRowVideo {
  id: string;
  videoId: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
  publishedAt: string;
  duration?: number;
  channel?: {
    id?: string;
    channelId?: string;
    name?: string;
    thumbnailUrl?: string;
  };
  audioFeatures?: AudioFeatures | null;
}

export const toDeckVideo = (video: DeckRowVideo): Video =>
  ({
    ...video,
    channelId: video.channel?.channelId || video.channel?.id || '',
    publishedAt: video.publishedAt,
    dateAdded: video.publishedAt,
    createdAt: video.publishedAt,
    updatedAt: video.publishedAt,
  }) as unknown as Video;

export const featuresOf = (
  video: DeckRowVideo | null | undefined
): AudioFeatures | null => video?.audioFeatures ?? null;

export const metaBpm = (features: AudioFeatures | null): string =>
  features ? String(Math.round(features.tempo)) : '—';

export const metaKey = (features: AudioFeatures | null): string =>
  features ? formatKeyShort(features.key, features.mode) : '—';

export const metaCamelot = (features: AudioFeatures | null): string =>
  features ? getCamelotKey(features.key, features.mode) : '—';

export const formatTime = (seconds: number): string => {
  if (!seconds || seconds < 0) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};
